import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { IPostingPlanViewEntity } from '~/domain/PermanentJobs';
import { CheckSingleIcon } from '~/images/icons';
import { formatListingFee } from '~/components/PermanentJobsV2/utils';

interface IHiringPlanCardProps {
  plan?: IPostingPlanViewEntity;
}

export const HiringPlanCard = ({ plan }: IHiringPlanCardProps) => {
  const price = plan?.finalPrice ? formatListingFee(plan.finalPrice) : '-';

  return (
    <Column
      gap={4}
      py={6}
      px={16}
      className="border border-neutral-100 rounded-lg bg-shades-0"
    >
      <Typography as="span" bold color={colors.neutral[600]} size="heading_3">
        Your Hiring Plan
      </Typography>

      <Column gap={4}>
        <Row gap={1}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span" color={colors.neutral[600]}>
              <Typography as="span" bold>Every applicant is pre-screened.</Typography> No sorting through unqualified
              resumes.
            </Typography>
          </Column>
        </Row>
        <Row gap={1}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span" color={colors.neutral[600]}>
              <Typography as="span" bold>No scheduling headaches.</Typography> Set your interview times, and professionals
              can apply directly to them.
            </Typography>
          </Column>
        </Row>
        <Row gap={1}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span" color={colors.neutral[600]}>
              <Typography as="span" bold>Tap into GoTu&apos;s active network.</Typography> Reach candidates who
              aren&apos;t browsing job boards.
            </Typography>
          </Column>
        </Row>
      </Column>

      <Column
        pt={6}
        pb={8}
        px={6}
        className="rounded-field bg-shades-0 shadow-elevation-4"
      >
        <Typography as="span" size="body_large" bold color={colors.neutral[600]}>
          Job Listing Fee
        </Typography>
        <Typography as="span" size="caption" color={colors.neutral[500]}>
          <Typography as="span" size="heading_2" bold color={colors.neutral[600]}>
            ${price}
          </Typography>{' '}
          /monthly
        </Typography>
        <Typography as="span" size="body_small" bold color={colors.primary[500]} style={{ marginTop: 10 }}>
          Your job will immediately become active and notify nearby candidates.
        </Typography>
      </Column>
    </Column>
  );
};
